// GraphQL API manager

import _ from 'lodash'

class APIManager {
    constructor(){
    }  

    // Prepare data for use (Relay related)
    prepareData(apolloData, singleNodeToObject = true){
        console.log(apolloData)
        const edges = apolloData.edges;
        if(!edges) return apolloData;
        if(edges.length == 0) return null
        if(edges.length > 1){
            let list = [];
            edges.forEach(edge => {
                list.push(edge.node);
            });
            return list;
        } 

        return (singleNodeToObject) ? edges[0].node : [edges[0].node];
    }

    prepareSyncForSaving(sync){
        const syncToSave = _.cloneDeep(sync)
        delete syncToSave.columnsMappings;
        delete syncToSave.direction;
        delete syncToSave.id
        console.log(syncToSave)
        return syncToSave
    }
}

export default new APIManager()